(function () {
  const installButtonSelector = '[data-ashoka-install-button]';
  const installedStorageKey = 'ashokaPwaInstalled';
  let deferredInstallPrompt = null;
  let modal = null;
  let installFallbackTimer = null;

  const userAgent = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(userAgent);
  const isChromium = /Chrome|CriOS|Edg|OPR|SamsungBrowser/i.test(userAgent);
  const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(userAgent);

  function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  function updateMobileViewportHeight() {
    const viewportHeight = window.visualViewport && window.visualViewport.height ? window.visualViewport.height : window.innerHeight;
    if (!viewportHeight) return;
    document.documentElement.style.setProperty('--at-mobile-viewport-height', `${Math.round(viewportHeight)}px`);
  }

  function markInstalled() {
    document.documentElement.classList.add('ashoka-pwa-installed');
    try {
      window.localStorage.setItem(installedStorageKey, 'true');
    } catch (error) {}
  }

  function hasInstalledFlag() {
    try {
      return window.localStorage.getItem(installedStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function hideInstallSurfaces() {
    document.querySelectorAll(installButtonSelector).forEach((button) => {
      const section = button.closest('.ashoka-install-app-banner, .ashoka-install-app-editorial-link, .ashoka-footer-install-app');
      if (section) {
        section.hidden = true;
      } else {
        button.hidden = true;
      }
    });
  }

  function updateInstallVisibility() {
    if (isStandalone()) {
      document.documentElement.classList.add('ashoka-pwa-standalone');
      markInstalled();
      hideInstallSurfaces();
      return;
    }

    if (hasInstalledFlag()) {
      document.documentElement.classList.add('ashoka-pwa-installed');
      hideInstallSurfaces();
    }
  }

  function injectModalStyles() {
    if (document.getElementById('ashoka-install-app-styles')) return;

    const style = document.createElement('style');
    style.id = 'ashoka-install-app-styles';
    style.textContent = `
      .ashoka-install-modal[hidden] { display: none !important; }
      .ashoka-install-modal {
        position: fixed;
        inset: 0;
        z-index: 2147483600;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 16px;
        background: rgba(31, 27, 24, 0.42);
      }
      .ashoka-install-modal__panel {
        width: min(100%, 420px);
        border-radius: 8px;
        background: #fffaf5;
        color: #1f1b18;
        box-shadow: 0 18px 50px rgba(31, 27, 24, 0.24);
        overflow: hidden;
      }
      .ashoka-install-modal__body { padding: 18px; }
      .ashoka-install-modal__eyebrow {
        margin: 0 0 6px;
        color: #9b593d;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0;
        text-transform: uppercase;
      }
      .ashoka-install-modal__title {
        margin: 0;
        font-size: 20px;
        line-height: 1.2;
      }
      .ashoka-install-modal__text {
        margin: 10px 0 0;
        color: #5f554e;
        font-size: 14px;
        line-height: 1.45;
      }
      .ashoka-install-modal__steps {
        margin: 14px 0 0;
        padding-left: 20px;
        color: #342d28;
        font-size: 14px;
        line-height: 1.5;
      }
      .ashoka-install-modal__actions {
        display: flex;
        gap: 10px;
        padding: 0 18px 18px;
      }
      .ashoka-install-modal__button {
        min-height: 42px;
        border: 1px solid rgba(155, 89, 61, 0.28);
        border-radius: 6px;
        padding: 0 14px;
        background: transparent;
        color: #1f1b18;
        font: inherit;
        font-weight: 700;
      }
      .ashoka-install-modal__button--primary {
        background: #9b593d;
        color: #ffffff;
      }
    `;
    document.head.appendChild(style);
  }

  function getInstructionContent() {
    if (isIOS && isSafari) {
      return {
        title: 'Add Ashoka Threads to your iPhone',
        text: 'iPhone installs websites from Safari. Use the share menu, then add the site to your Home Screen.',
        steps: ['Tap the Share button in Safari.', 'Scroll and tap Add to Home Screen.', 'Tap Add.'],
        canShare: typeof navigator.share === 'function',
      };
    }

    if (isIOS) {
      return {
        title: 'Open in Safari to install',
        text: 'iPhone Chrome cannot install this as a Home Screen app. Open Ashoka Threads in Safari, then use Share and Add to Home Screen.',
        steps: ['Copy or open ashokathreads.com in Safari.', 'Tap Share.', 'Tap Add to Home Screen.'],
        canShare: typeof navigator.share === 'function',
      };
    }

    if (isAndroid && isChromium) {
      return {
        title: 'Install Ashoka Threads',
        text: 'Chrome has not made the app install prompt available yet on this device.',
        steps: ['Close this message.', 'Refresh Ashoka Threads once.', 'Tap Install App again. If Chrome still says Add to Home screen, the phone is creating a browser shortcut instead of a standalone app.'],
        canShare: false,
      };
    }

    return {
      title: 'Add Ashoka Threads to your device',
      text: 'Use your browser menu to add this site to your home screen or apps.',
      steps: ['Open the browser menu.', 'Choose Install app or Add to Home screen.', 'Confirm the action.'],
      canShare: false,
    };
  }

  function closeModal() {
    if (modal) modal.hidden = true;
  }

  function showInstructionModal() {
    injectModalStyles();
    const content = getInstructionContent();

    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'ashoka-install-modal';
      modal.hidden = true;
      modal.innerHTML = `
        <div class="ashoka-install-modal__panel" role="dialog" aria-modal="true" aria-labelledby="ashoka-install-title">
          <div class="ashoka-install-modal__body">
            <p class="ashoka-install-modal__eyebrow">Ashoka Threads</p>
            <h2 class="ashoka-install-modal__title" id="ashoka-install-title"></h2>
            <p class="ashoka-install-modal__text"></p>
            <ol class="ashoka-install-modal__steps"></ol>
          </div>
          <div class="ashoka-install-modal__actions">
            <button type="button" class="ashoka-install-modal__button ashoka-install-modal__button--primary" data-ashoka-share-button>Open Share</button>
            <button type="button" class="ashoka-install-modal__button" data-ashoka-install-close>Done</button>
          </div>
        </div>
      `;
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('[data-ashoka-install-close]')) closeModal();
      });
      modal.querySelector('[data-ashoka-share-button]').addEventListener('click', async () => {
        if (typeof navigator.share !== 'function') return;
        try {
          await navigator.share({
            title: document.title,
            text: 'Add Ashoka Threads to your Home Screen.',
            url: window.location.origin,
          });
        } catch (error) {}
      });
      document.body.appendChild(modal);
    }

    modal.querySelector('.ashoka-install-modal__title').textContent = content.title;
    modal.querySelector('.ashoka-install-modal__text').textContent = content.text;
    modal.querySelector('.ashoka-install-modal__steps').innerHTML = content.steps.map((step) => `<li>${step}</li>`).join('');
    modal.querySelector('[data-ashoka-share-button]').hidden = !content.canShare;
    modal.hidden = false;
  }

  async function runInstallPrompt(event) {
    event.preventDefault();

    if (isStandalone() || hasInstalledFlag()) {
      updateInstallVisibility();
      return;
    }

    if (deferredInstallPrompt) {
      window.clearTimeout(installFallbackTimer);
      const promptEvent = deferredInstallPrompt;
      deferredInstallPrompt = null;
      promptEvent.prompt();
      const choice = await promptEvent.userChoice;
      if (choice && choice.outcome === 'accepted') {
        markInstalled();
        hideInstallSurfaces();
      }
      return;
    }

    if (isAndroid && isChromium) {
      window.clearTimeout(installFallbackTimer);
      installFallbackTimer = window.setTimeout(() => {
        if (!deferredInstallPrompt) showInstructionModal();
      }, 900);
      return;
    }

    if (isIOS && isSafari && typeof navigator.share === 'function') {
      try {
        await navigator.share({
          title: document.title,
          text: 'Add Ashoka Threads to your Home Screen.',
          url: window.location.origin,
        });
        showInstructionModal();
        return;
      } catch (error) {
        showInstructionModal();
        return;
      }
    }

    showInstructionModal();
  }

  function bindInstallButtons(root) {
    root.querySelectorAll(installButtonSelector).forEach((button) => {
      if (button.dataset.ashokaInstallBound === 'true') return;
      button.dataset.ashokaInstallBound = 'true';
      button.addEventListener('click', runInstallPrompt);
    });
  }

  function initInstallApp() {
    updateMobileViewportHeight();
    updateInstallVisibility();
    bindInstallButtons(document);

    document.addEventListener('shopify:section:load', (event) => {
      bindInstallButtons(event.target);
      updateInstallVisibility();
    });
  }

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    document.documentElement.classList.add('ashoka-pwa-install-ready');
  });

  window.addEventListener('resize', updateMobileViewportHeight, { passive: true });
  window.addEventListener('orientationchange', updateMobileViewportHeight, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateMobileViewportHeight, { passive: true });
    window.visualViewport.addEventListener('scroll', updateMobileViewportHeight, { passive: true });
  }

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    markInstalled();
    hideInstallSurfaces();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstallApp, { once: true });
  } else {
    initInstallApp();
  }
})();
